import CustomCursor from "custom-cursor-react";
import "custom-cursor-react/dist/index.css";
import styled from "styled-components";

const Cursor = () => {
  return (
    <Custom>
      <CustomCursor
        targets={[
          ".link",
          ".your-css-selector, button, a, img, Link, Bubbles, .higher-z, .lower-z, GradientButton",
        ]}
        customClass="custom-cursor"
        dimensions={50}
        fill="transparent"
        strokeColor="white"
        strokeWidth={1.5}
        opacity={0.4}
        smoothness={{
          movement: 0.15,
          scale: 0.1,
          opacity: 0.5,
        }}
        targetOpacity={0.6}
        targetScale={2}
      />
    </Custom>
  );
};

const Custom = styled.div`
  @media (max-width: 1024px) {
    display: none;
  }
`;

export default Cursor;
